/* tslint:disable */
/* eslint-disable */
/**
 * RateRelief API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PolicyDetailModel
 */
export interface PolicyDetailModel {
    /**
     * 
     * @type {string}
     * @memberof PolicyDetailModel
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolicyDetailModel
     */
    createdBy?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof PolicyDetailModel
     */
    createdDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PolicyDetailModel
     */
    timePeriodDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof PolicyDetailModel
     */
    policyNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolicyDetailModel
     */
    groupName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof PolicyDetailModel
     */
    originalEffectiveDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PolicyDetailModel
     */
    reissueDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof PolicyDetailModel
     */
    state_JanReissue?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PolicyDetailModel
     */
    targetedGroup?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PolicyDetailModel
     */
    override?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyDetailModel
     */
    total?: number;
    /**
     * 
     * @type {string}
     * @memberof PolicyDetailModel
     */
    reissueType?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PolicyDetailModel
     */
    riskFilter?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyDetailModel
     */
    employeeMedCountEE?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyDetailModel
     */
    employeeMedCountES?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyDetailModel
     */
    employeeMedCountEC?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyDetailModel
     */
    employeeMedCountFF?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyDetailModel
     */
    employeeMedCountTOT?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyDetailModel
     */
    employeeMedCountOldTOT?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyDetailModel
     */
    priorRelief?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyDetailModel
     */
    newPremiumEquivalent?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyDetailModel
     */
    estimatedStandardNBRate?: number;
    /**
     * 
     * @type {string}
     * @memberof PolicyDetailModel
     */
    network_JanReissue?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PolicyDetailModel
     */
    aggressiveRating?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PolicyDetailModel
     */
    optionsShutoff?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PolicyDetailModel
     */
    pureUWLoad?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyDetailModel
     */
    currentPremiumEquivalent?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyDetailModel
     */
    slTotalEstimated?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PolicyDetailModel
     */
    dentalVisionGroup?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PolicyDetailModel
     */
    eligibleRateRelief?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PolicyDetailModel
     */
    trend?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyDetailModel
     */
    sizeAndCensus?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyDetailModel
     */
    maraImpact?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyDetailModel
     */
    other?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyDetailModel
     */
    rateIncrease_BAFO?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyDetailModel
     */
    increaseReduction?: number;
    /**
     * 
     * @type {string}
     * @memberof PolicyDetailModel
     */
    requestStatus?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolicyDetailModel
     */
    requestedBy?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof PolicyDetailModel
     */
    requestedDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof PolicyDetailModel
     */
    assignedTo?: string | null;
}

/**
 * Check if a given object implements the PolicyDetailModel interface.
 */
export function instanceOfPolicyDetailModel(value: object): value is PolicyDetailModel {
    return true;
}

export function PolicyDetailModelFromJSON(json: any): PolicyDetailModel {
    return PolicyDetailModelFromJSONTyped(json, false);
}

export function PolicyDetailModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PolicyDetailModel {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdDate': json['createdDate'] == null ? undefined : (new Date(json['createdDate'])),
        'timePeriodDate': json['timePeriodDate'] == null ? undefined : (new Date(json['timePeriodDate'])),
        'policyNumber': json['policyNumber'] == null ? undefined : json['policyNumber'],
        'groupName': json['groupName'] == null ? undefined : json['groupName'],
        'originalEffectiveDate': json['originalEffectiveDate'] == null ? undefined : (new Date(json['originalEffectiveDate'])),
        'reissueDate': json['reissueDate'] == null ? undefined : (new Date(json['reissueDate'])),
        'state_JanReissue': json['state_JanReissue'] == null ? undefined : json['state_JanReissue'],
        'targetedGroup': json['targetedGroup'] == null ? undefined : json['targetedGroup'],
        'override': json['override'] == null ? undefined : json['override'],
        'total': json['total'] == null ? undefined : json['total'],
        'reissueType': json['reissueType'] == null ? undefined : json['reissueType'],
        'riskFilter': json['riskFilter'] == null ? undefined : json['riskFilter'],
        'employeeMedCountEE': json['employeeMedCountEE'] == null ? undefined : json['employeeMedCountEE'],
        'employeeMedCountES': json['employeeMedCountES'] == null ? undefined : json['employeeMedCountES'],
        'employeeMedCountEC': json['employeeMedCountEC'] == null ? undefined : json['employeeMedCountEC'],
        'employeeMedCountFF': json['employeeMedCountFF'] == null ? undefined : json['employeeMedCountFF'],
        'employeeMedCountTOT': json['employeeMedCountTOT'] == null ? undefined : json['employeeMedCountTOT'],
        'employeeMedCountOldTOT': json['employeeMedCountOldTOT'] == null ? undefined : json['employeeMedCountOldTOT'],
        'priorRelief': json['priorRelief'] == null ? undefined : json['priorRelief'],
        'newPremiumEquivalent': json['newPremiumEquivalent'] == null ? undefined : json['newPremiumEquivalent'],
        'estimatedStandardNBRate': json['estimatedStandardNBRate'] == null ? undefined : json['estimatedStandardNBRate'],
        'network_JanReissue': json['network_JanReissue'] == null ? undefined : json['network_JanReissue'],
        'aggressiveRating': json['aggressiveRating'] == null ? undefined : json['aggressiveRating'],
        'optionsShutoff': json['optionsShutoff'] == null ? undefined : json['optionsShutoff'],
        'pureUWLoad': json['pureUWLoad'] == null ? undefined : json['pureUWLoad'],
        'currentPremiumEquivalent': json['currentPremiumEquivalent'] == null ? undefined : json['currentPremiumEquivalent'],
        'slTotalEstimated': json['slTotalEstimated'] == null ? undefined : json['slTotalEstimated'],
        'dentalVisionGroup': json['dentalVisionGroup'] == null ? undefined : json['dentalVisionGroup'],
        'eligibleRateRelief': json['eligibleRateRelief'] == null ? undefined : json['eligibleRateRelief'],
        'trend': json['trend'] == null ? undefined : json['trend'],
        'sizeAndCensus': json['sizeAndCensus'] == null ? undefined : json['sizeAndCensus'],
        'maraImpact': json['maraImpact'] == null ? undefined : json['maraImpact'],
        'other': json['other'] == null ? undefined : json['other'],
        'rateIncrease_BAFO': json['rateIncrease_BAFO'] == null ? undefined : json['rateIncrease_BAFO'],
        'increaseReduction': json['increaseReduction'] == null ? undefined : json['increaseReduction'],
        'requestStatus': json['requestStatus'] == null ? undefined : json['requestStatus'],
        'requestedBy': json['requestedBy'] == null ? undefined : json['requestedBy'],
        'requestedDate': json['requestedDate'] == null ? undefined : (new Date(json['requestedDate'])),
        'assignedTo': json['assignedTo'] == null ? undefined : json['assignedTo'],
    };
}

export function PolicyDetailModelToJSON(json: any): PolicyDetailModel {
    return PolicyDetailModelToJSONTyped(json, false);
}

export function PolicyDetailModelToJSONTyped(value?: PolicyDetailModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdBy': value['createdBy'],
        'createdDate': value['createdDate'] == null ? undefined : ((value['createdDate']).toISOString()),
        'timePeriodDate': value['timePeriodDate'] == null ? undefined : ((value['timePeriodDate']).toISOString()),
        'policyNumber': value['policyNumber'],
        'groupName': value['groupName'],
        'originalEffectiveDate': value['originalEffectiveDate'] == null ? undefined : ((value['originalEffectiveDate']).toISOString()),
        'reissueDate': value['reissueDate'] == null ? undefined : ((value['reissueDate']).toISOString()),
        'state_JanReissue': value['state_JanReissue'],
        'targetedGroup': value['targetedGroup'],
        'override': value['override'],
        'total': value['total'],
        'reissueType': value['reissueType'],
        'riskFilter': value['riskFilter'],
        'employeeMedCountEE': value['employeeMedCountEE'],
        'employeeMedCountES': value['employeeMedCountES'],
        'employeeMedCountEC': value['employeeMedCountEC'],
        'employeeMedCountFF': value['employeeMedCountFF'],
        'employeeMedCountTOT': value['employeeMedCountTOT'],
        'employeeMedCountOldTOT': value['employeeMedCountOldTOT'],
        'priorRelief': value['priorRelief'],
        'newPremiumEquivalent': value['newPremiumEquivalent'],
        'estimatedStandardNBRate': value['estimatedStandardNBRate'],
        'network_JanReissue': value['network_JanReissue'],
        'aggressiveRating': value['aggressiveRating'],
        'optionsShutoff': value['optionsShutoff'],
        'pureUWLoad': value['pureUWLoad'],
        'currentPremiumEquivalent': value['currentPremiumEquivalent'],
        'slTotalEstimated': value['slTotalEstimated'],
        'dentalVisionGroup': value['dentalVisionGroup'],
        'eligibleRateRelief': value['eligibleRateRelief'],
        'trend': value['trend'],
        'sizeAndCensus': value['sizeAndCensus'],
        'maraImpact': value['maraImpact'],
        'other': value['other'],
        'rateIncrease_BAFO': value['rateIncrease_BAFO'],
        'increaseReduction': value['increaseReduction'],
        'requestStatus': value['requestStatus'],
        'requestedBy': value['requestedBy'],
        'requestedDate': value['requestedDate'] == null ? undefined : ((value['requestedDate']).toISOString()),
        'assignedTo': value['assignedTo'],
    };
}

